<template>
  <div class="plug">
    <PlugIcon class="plug__icon" :style="cssVars" />
    <h4 class="plug__text" :class="'f' + fontSize">
      {{ localStorage.translations.pages.common['text']['net-dannyh'] }}
    </h4>
  </div>
</template>

<script>
import PlugIcon from 'components/icons/PlugIcon'

export default {
  name: 'Plug',
  components: { PlugIcon },
  props: {
    iconWidth: {
      type: [Number, String],
      default: '300px',
    },
    fontSize: {
      type: [Number, String],
      default: '60',
    },
  },
  data() {
    return {}
  },
  computed: {
    cssVars() {
      return {
        '--width': this.iconWidth,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.plug {
  flex-grow: 1;
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  justify-items: center;
  grid-template-rows: repeat(2, max-content);
  align-content: center;
  &__icon {
    width: var(--width);
    height: auto;
    align-items: center;
  }
  &__text {
    color: #bec9cf;
    text-align: center;
  }
}
</style>
